export default {
    exportFile: '/basic/exportFiles/list',
    download: '/basic/exportFiles/download',
    timingExport: '/basic/ppm/timingExport'
};
